import * as Sentry from "@sentry/react";

const initSentry = () => {
  const {
    REACT_APP_SENTRY_DSN,
    REACT_APP_SENTRY_SAMPLE_RATE,
    REACT_APP_SENTRY_ENVIORNMENT,
  } = process.env;

  Sentry.init({
    dsn: REACT_APP_SENTRY_DSN,
    integrations: [
      new Sentry.Integrations.Breadcrumbs({
        console: false,
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: true,
      }),
    ],
    environment: REACT_APP_SENTRY_ENVIORNMENT,
    tracesSampleRate: Number(REACT_APP_SENTRY_SAMPLE_RATE || 1.0),
  });
};

export default initSentry;
